import { ACTION_TYPE } from "../../Services/Constants/index";
export const CollapsedSidenavAction = (collapsed) => async (dispatch) => {
  try {
    await dispatch({
      type: ACTION_TYPE.SIDENAV_WIDTH,
      payload: collapsed,
    });
  } catch (error) {}
};
